// extracted by mini-css-extract-plugin
export default {"form":"NewsletterForm_form__u3T5c"};